import { TextField, Stack, InputAdornment, Button } from "@mui/material"
import { useState } from "react"
import SearchRoundedIcon from "@mui/icons-material/SearchRounded"
import AddCourseModal from "../modals/AddCourseModal"
import DeleteCourseModal from "../modals/DeleteCourseModal"
import { getAllCourses, getCourseFilters, getCourseSort } from "../../api"
import ListData from "../common/ListData"
import { ListCourseCard } from "../cards/ListCourseCard"
import { useParams } from "react-router-dom"

const Courses = () => {
  const [search, setSearch] = useState("")
  const [editModal, setEditModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedCourse, setSelectedCourse] = useState(null)
  const { id } = useParams()

  const [fetchData, setFetchData] = useState(false)

  const handleSearchChange = (event) => setSearch(event.target.value)

  const openEditModal = (course) => {
    setSelectedCourse(course)
    setEditModal(true)
  }
  const closeEditModal = () => setEditModal(false)
  const openDeleteModal = (course) => {
    setSelectedCourse(course)
    setDeleteModal(true)
  }
  const closeDeleteModal = () => setDeleteModal(false)

  const CTA = () => (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      alignItems="center"
    >
      <TextField
        value={search}
        onChange={handleSearchChange}
        placeholder="Search Courses..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchRoundedIcon />
            </InputAdornment>
          ),
        }}
      />

      <Button onClick={() => openEditModal(null)} variant="contained">
        Add Course
      </Button>
    </Stack>
  )

  return (
    <>
      <ListData
        getFilters={getCourseFilters}
        getSort={getCourseSort}
        getAllData={getAllCourses}
        initialFilters={id && {filter: {programId: id}}}
        HeaderRight={CTA}
        Card={ListCourseCard}
        refresh={fetchData}
      />

      {/* <LoadingContent loading={loading}>
        <Grid container spacing={3} marginTop={2}>
          {courses.map((course, i) => (
            <Grid key={i} item xs={3}>
              <CourseCard
                key={i}
                data={course}
                edit={() => openEditModal(course)}
                deleteCourse={() => openDeleteModal(course)}
              />
            </Grid>
          ))}
        </Grid>
      </LoadingContent> */}
      <AddCourseModal
        isOpen={editModal}
        close={closeEditModal}
        course={selectedCourse}
        refresh={() => {
          setFetchData(!fetchData)
        }}
      />
      <DeleteCourseModal
        isOpen={deleteModal}
        close={closeDeleteModal}
        course={selectedCourse}
        refresh={() => {
          setFetchData(!fetchData)
        }}
      />
    </>
  )
}

export default Courses
